<template>
  <main>
    <About />
    <Projects />
    <Contact />
  </main>
</template>

<script>
import About from "../components/About";
import Projects from "../components/Projects";
import Contact from "../components/Contact";

export default {
  name: "home",
  components: {
    About,
    Projects,
    Contact
  }
};
</script>

<style lang="scss" scoped>
</style>